//This file exists because I needed to use a hook in InHouse.js
import React from 'react'
import {useMySitesPanelChange} from '../MySites/useMySitesPanelChange'

export default function OpenMaterialInfoButton({className}) {
	const mySitesPanels = useMySitesPanelChange();
    return <button className={"rounded-pill btn btn-primary " + className} onClick={() => mySitesPanels.add("material-info")}>Material Info</button>
}